export const VISITORS_PER_HOUR_GET_ALL_SUCCESS = 'VISITORS_PER_HOUR_GET_ALL_SUCCESS';
export const VISITORS_PER_HOUR_GET_ALL_FAILURE = 'USER_PER_HOUR_GET_ALL_FAILURE';
export const VISITORS_PER_HOUR_DATA_IS_LOADING = 'USER_PER_HOUR_DATA_IS_LOADING';
